// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/like_generation.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionGenerationLike } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/like_generation.proto.
 */
export const file_vision_generations_v1_like_generation: GenFile = /*@__PURE__*/
  fileDesc("Cit2aXNpb24vZ2VuZXJhdGlvbnMvdjEvbGlrZV9nZW5lcmF0aW9uLnByb3RvEhxwcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxIoQBChVMaWtlR2VuZXJhdGlvblJlcXVlc3QSSgoGcGFyYW1zGAEgASgLMjoucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5MaWtlR2VuZXJhdGlvblJlcXVlc3QuUGFyYW1zGh8KBlBhcmFtcxIVCg1nZW5lcmF0aW9uX2lkGAEgASgJIrIBChZMaWtlR2VuZXJhdGlvblJlc3BvbnNlEksKBnJlc3VsdBgBIAEoCzI7LnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuTGlrZUdlbmVyYXRpb25SZXNwb25zZS5SZXN1bHQaSwoGUmVzdWx0EkEKBWxpa2VzGAEgAygLMjIucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5WaXNpb25HZW5lcmF0aW9uTGlrZWIGcHJvdG8z", [file_vision_generations_v1_vision_generation]);

/**
 * @generated from message protos.vision.generations.v1.LikeGenerationRequest
 */
export type LikeGenerationRequest = Message<"protos.vision.generations.v1.LikeGenerationRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.LikeGenerationRequest.Params params = 1;
   */
  params?: LikeGenerationRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.LikeGenerationRequest.
 * Use `create(LikeGenerationRequestSchema)` to create a new message.
 */
export const LikeGenerationRequestSchema: GenMessage<LikeGenerationRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_like_generation, 0);

/**
 * @generated from message protos.vision.generations.v1.LikeGenerationRequest.Params
 */
export type LikeGenerationRequest_Params = Message<"protos.vision.generations.v1.LikeGenerationRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.LikeGenerationRequest.Params.
 * Use `create(LikeGenerationRequest_ParamsSchema)` to create a new message.
 */
export const LikeGenerationRequest_ParamsSchema: GenMessage<LikeGenerationRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_like_generation, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.LikeGenerationResponse
 */
export type LikeGenerationResponse = Message<"protos.vision.generations.v1.LikeGenerationResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.LikeGenerationResponse.Result result = 1;
   */
  result?: LikeGenerationResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.LikeGenerationResponse.
 * Use `create(LikeGenerationResponseSchema)` to create a new message.
 */
export const LikeGenerationResponseSchema: GenMessage<LikeGenerationResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_like_generation, 1);

/**
 * @generated from message protos.vision.generations.v1.LikeGenerationResponse.Result
 */
export type LikeGenerationResponse_Result = Message<"protos.vision.generations.v1.LikeGenerationResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.generations.v1.VisionGenerationLike likes = 1;
   */
  likes: VisionGenerationLike[];
};

/**
 * Describes the message protos.vision.generations.v1.LikeGenerationResponse.Result.
 * Use `create(LikeGenerationResponse_ResultSchema)` to create a new message.
 */
export const LikeGenerationResponse_ResultSchema: GenMessage<LikeGenerationResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_like_generation, 1, 0);

